import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SearchCardI } from '../../models/list-view/kanbanList';

@Component({
  selector: 'anterasoftware-kanban-saved-search-bar',
  templateUrl: './kanban-saved-search-bar.component.html',
  styleUrls: ['./kanban-saved-search-bar.component.scss']
})
export class KanbanSavedSearchBarComponent implements OnInit {

  @Input() public savedSearchList: SearchCardI[] = [];
  @Output() public onSavedSearchSelect: EventEmitter<any> = new EventEmitter();
  @Output() public fetchNextKanbanData: EventEmitter<any> = new EventEmitter();
  @Input() public displayView: string = "";
  @Output() public fetchLastKanbanData: EventEmitter<any> = new EventEmitter();
  
  constructor() { }

  public ngOnInit(): void {

  }

  /**
   * Emits event on selection of card.
   *
   * @param {SearchCardI} card
   * @returns {void}
   */
  public onSelect(card: SearchCardI): void{
    this.onSavedSearchSelect.emit(card);
  }

  /**
   * Returns list from index 10 and beyond.
   *
   * @param {SearchCardI[]} searchList
   * @returns {SearchCardI[]}
   */
  public getRemainingList(searchList: SearchCardI[]){
    if(searchList?.length > 10){
      return searchList.slice(10)
    }

    return [];
  }

  public fetchNextData() {
    this.fetchNextKanbanData.emit();
  }

  public fetchLastData() {
    this.fetchLastKanbanData.emit();
  }
}
